import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  navContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground3,
    justifyContent: 'start',
  },
  SidebarContainer: {
    display: 'flex',
    alignItems: 'left',
  },
  MenuIconContainer: {
    padding: '0 22px',
    height: '50px',
  },
  NavIconContainer: {
    padding: '0 22px',
    height: '50px',
  },
  MenuIcon: {
    cursor: 'pointer',
    height: '44px',
    width: '44px',
  },
  linkContainer: {
    height: '44px',
    border: '0px',
    padding: '0px 14px',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: 'none',
    alignItems: 'center',
    justifyItems: 'start',
    position: 'relative',
    '&:hover': {
      backgroundColor: tokens.colorNeutralBackground1,
    },
    '&:hover:after': {
      content: '""',
      position: 'absolute',
      insetInlineStart: 0,
      insetBlockStart: '8px',
      insetBlockEnd: '8px',
      width: '4px',
      borderRadius: '100%',
      backgroundColor: tokens.colorNeutralForegroundDisabled,
    },
  },
  linkContainerContrast: {
    '&:hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  linkActive: {
    fontWeight: 600,
    '&:after': {
      content: '""',
      position: 'absolute',
      insetInlineStart: 0,
      insetBlockStart: '8px',
      insetBlockEnd: '8px',
      width: '4px',
      borderRadius: '100%',
      backgroundColor: tokens.colorBrandStroke1,
    },
    '&:hover:after': {
      backgroundColor: tokens.colorBrandStroke1,
    },
  },
  text: {
    marginLeft: '20px',
  },
  experienceContainer: {
    height: "44px",
    border: "0px",
    padding: "0px 14px",
    borderRadius: "4px",
    backgroundColor: "none",
    position: "relative",
    fontWeight: 400,
    fontSize: "smaller",
    letterSpacing: "0%"
  },
  experienceText: {
    marginLeft: "20px",
    marginBottom: "4px",
    color: tokens.colorNeutralForeground3,
    fontSize: "small"
  },
  clientSwitcherContainer: {
    height: "44px",
    border: "0px",
    padding: "0px 14px",
    borderRadius: "4px",
    cursor: "pointer",
    backgroundColor: "none",
    color: tokens.colorNeutralForeground1,
    position: "relative",
    fontWeight: 600,
    fontSize: "small"
  }
});
